module.exports = __webpack_public_path__ + "static/img/Helios.ce18989.svg";